// ============================================================
// HABIT OS — Einwilligung Gesundheitsdaten (Art. 9 Abs. 2 lit. a DSGVO)
//
// Bei jeder inhaltlichen Änderung am Text: CONSENT_VERSION erhöhen.
// Dann müssen alle neu zustimmen. Die gleiche Version steht in
// supabase/functions/_shared/consent.ts (serverseitige Prüfung).
// ============================================================

export const CONSENT_PURPOSE = "ai_health";
export const CONSENT_VERSION = "2026-11-02";

export const CONSENT_TITLE = "Bevor du mit deinem KI-Begleiter sprichst";

export const CONSENT_SECTIONS = [
  {
    heading: "Was verarbeitet wird",
    text: "Deine Nachrichten im Chat, Fotos von Supplement-Etiketten und deine Gewohnheiten mit Fortschritt (z. B. erledigte Habits, Streak). Daraus können sich Angaben zu deiner Gesundheit ergeben, etwa welche Nahrungsergänzungsmittel du nimmst oder wie es dir geht.",
  },
  {
    heading: "Wofür",
    text: "Für die Antworten deines KI-Begleiters, die Etikett-Analyse, den Wochenrückblick und Push-Nachrichten deines Begleiters.",
  },
  {
    heading: "Wer die Daten erhält",
    text: "Gespeichert werden sie bei Supabase in Frankfurt (EU). Um Antworten zu erzeugen, übermitteln wir sie an Anthropic PBC in den USA, also in ein Land außerhalb der EU. Anthropic nutzt diese Daten laut seinen Geschäftsbedingungen nicht zum Training seiner KI-Modelle.",
  },
  {
    heading: "Wie lange",
    text: "Dein Chatverlauf bleibt gespeichert, bis du ihn löschst oder dein Konto löschst.",
  },
  {
    heading: "Freiwillig und jederzeit widerrufbar",
    text: "Ohne Einwilligung kannst du Habit OS weiter nutzen, nur der KI-Begleiter bleibt aus. Du kannst die Einwilligung jederzeit im Profil unter „Datenschutz“ widerrufen. Danach senden wir nichts mehr an die KI. Was bis dahin verarbeitet wurde, bleibt rechtmäßig. Deinen Chatverlauf kannst du dort ebenfalls löschen.",
  },
];

export const CONSENT_CHECKBOX =
  "Ich bin mindestens 16 Jahre alt und willige ein, dass Habit OS meine Gesundheitsdaten wie beschrieben verarbeitet und dafür an Anthropic (USA) übermittelt.";
